"use client";

import { ProductTrackingProvider as DesignSystemProductTrackingProvider } from "@offstreetparking/design-system/providers";
import { usePathname, useSearchParams } from "next/navigation";
import type { ReactNode } from "react";
import { env } from "~/env";

export function ProductTrackingProvider({ children }: { children: ReactNode }) {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	return (
		<DesignSystemProductTrackingProvider
			apiKey={env.NEXT_PUBLIC_POSTHOG_KEY}
			apiHost={env.NEXT_PUBLIC_POSTHOG_HOST}
			personProfiles="never"
			disableSurveys
			pathname={pathname}
			searchParams={searchParams}
		>
			{children}
		</DesignSystemProductTrackingProvider>
	);
}
